import { memo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import TouchableWithoutFeedback from "src/components/TouchableWithoutFeedback";
import { paddingLarge } from "src/styles/spacing";
import { Image, ImageProps } from "src/swsh-native";
import ToggleBadge, { ToggleVariant } from "../ToggleBadge";

const ToggleImage = ({
	isSelected,
	onPress,
	containerStyle,
	toggleVariant,
	dim = "auto",
	alt,
	...imageProps
}: Omit<ImageProps, "dim" | "style"> & { dim?: ImageProps["dim"] } & {
	isSelected: boolean;
	onPress: () => void;
	toggleVariant?: ToggleVariant;
	containerStyle?: StyleProp<ViewStyle>;
}) => {
	return (
		<TouchableWithoutFeedback onPress={onPress} style={containerStyle}>
			<Image
				alt={alt}
				{...imageProps}
				pointerEvents="none"
				style={{
					width: "100%",
					height: "100%",
				}}
				dim={dim}
			/>
			{!!toggleVariant && (
				<ToggleBadge
					variant={toggleVariant}
					colorVariant={toggleVariant === "SingleSelect" ? "Selection" : "Action"}
					isSelected={isSelected}
					style={{
						position: "absolute",
						bottom: paddingLarge,
						right: paddingLarge,
					}}
				/>
			)}
		</TouchableWithoutFeedback>
	);
};

export default memo(ToggleImage);
